import { render, staticRenderFns } from "./PlanVariantB.vue?vue&type=template&id=ac574be0&scoped=true&"
import script from "./PlanVariantB.vue?vue&type=script&lang=js&"
export * from "./PlanVariantB.vue?vue&type=script&lang=js&"
import style0 from "./PlanVariantB.vue?vue&type=style&index=0&id=ac574be0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac574be0",
  null
  
)

export default component.exports